import React from 'react';

import type { IdAccountTypeDto } from '@/services/ws-crm/src/main/resources/rest-api';
import { getAccountTypes } from '@/services/ws-crm/src/main/resources/rest-api';
import { useSubscribe } from '@/js/libs/observable';
import { useRequest } from '@/js/libs/use-request';

import { DEFAULT_DEBOUNCE_DELAY } from 'src/constants';
import type { Option } from 'src/types';

type UseAccountTypesOptionsReturn = {
  options: Option<IdAccountTypeDto>[];
  pending: boolean;
};

type UseAccountTypesOptions = () => UseAccountTypesOptionsReturn;

export const useAccountTypesOptions: UseAccountTypesOptions = () => {
  const getAccountTypesRequest = useRequest({
    apiMethod: getAccountTypes,
    params: {},
    debounce: DEFAULT_DEBOUNCE_DELAY,
  });

  const options = useSubscribe(
    getAccountTypesRequest.data$,
    (response) => response?.data.map((item) => ({ label: item.name, value: item.id })) ?? [],
  );
  const pending = useSubscribe(getAccountTypesRequest.pending$);

  return React.useMemo<UseAccountTypesOptionsReturn>(
    () => ({
      options,
      pending,
    }),
    [options, pending],
  );
};
